import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Stats } from '../components/sections/Stats';
import { Testimonials } from '../components/sections/Testimonials';
import { Includes } from '../components/sections/Includes';
import { Pricing } from '../components/sections/Pricing';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Footer } from '../components/sections/Footer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-brand-dark" data-id="element-178">
      <MetaPixel data-id="element-179" />
      <main data-id="element-180">
        <Hero data-id="element-181" />
        <Stats data-id="element-182" />
        <Includes data-id="element-183" />
        <Testimonials data-id="element-184" />
        <Pricing data-id="element-185" />
        <FAQ data-id="element-186" />
        <FinalCTA data-id="element-187" />
      </main>
      <Footer data-id="element-188" />
      <SocialProofPopup data-id="element-189" />
    </div>;
}